import { useState } from 'react';

// Components
// @ts-expect-error no types for this package
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {
  Search,
  // @ts-expect-error no types for this package
} from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { Form } from 'react-bootstrap';
import { Stack } from '@raptormaps/layout';
import { Button } from '@raptormaps/button';

//API
import RestApiV2 from '../../api/RestApiV2';
import type { OrgUser } from '../../api/types/OrgUser';

interface LegacyRolesProps {
  users: OrgUser[];
  setUsers: (users: OrgUser[]) => void;
}

export const LegacyRoles = ({ users, setUsers }: LegacyRolesProps) => {
  const [buttonDisabled, setButtonDisable] = useState(true);

  const api = new RestApiV2();

  const updateRole = (user: OrgUser, role: string, userlist: OrgUser[]) => {
    let changedUser: OrgUser;

    if (!user.roles) {
      user.roles = [];
    }
    //if user does not have role add it, otherwise remove it
    if (!user.roles?.includes(role)) {
      changedUser = { ...user, roles: [...user.roles, role] };
    } else {
      changedUser = { ...user, roles: user.roles.filter(r => r !== role) };
    }

    const newUsers = userlist.map(u => {
      return u.id === user.id ? changedUser : u;
    });
    setUsers(newUsers);
    setButtonDisable(false);
  };

  /**
   * Formats data and sends roles to backend to be saved
   * api - api_v2_raptor_admin_roles
   */
  const saveRoles = () => {
    //format data for route
    const data = users.reduce((acc, user) => {
      // @ts-expect-error user.id is always defined
      acc[user.id] = {
        raptoradmin: user.roles?.includes('raptoradmin'),
        solar: user.roles?.includes('solar'),
        reportbuilder: user.roles?.includes('reportbuilder'),
        farmbuilder: user.roles?.includes('farmbuilder'),
      };
      return acc;
    }, {});

    //send data
    api
      .put('/raptor_admin/roles', data)
      .then(res => {
        setButtonDisable(true);
      })
      .catch(err => {
        console.log(err);
      });
  };

  // @ts-expect-error not sure of the types here
  const formatData = (cell, row, rowIndex, params) => {
    return (
      <Form.Check
        checked={row['roles'].includes(params.col)}
        onChange={() => updateRole(row, params.col, params.users)}
      />
    );
  };

  const getColumns = (users: OrgUser[]) => [
    {
      dataField: 'email',
      text: 'Email',
      headerStyle: { width: '50%' },
    },
    {
      formatter: formatData,
      formatExtraData: { col: 'raptoradmin', users },
      text: 'Raptor Admin',
      align: 'center',
      headerAlign: 'center',
      dataField: 'raptoradmin',
    },
    {
      formatter: formatData,
      formatExtraData: { col: 'solar', users },
      text: 'Solar',
      align: 'center',
      headerAlign: 'center',
      dataField: 'solar',
    },
    {
      formatter: formatData,
      formatExtraData: { col: 'reportbuilder', users },
      text: 'Report Builder',
      align: 'center',
      headerAlign: 'center',
      dataField: 'reportbuilder',
    },
    {
      formatter: formatData,
      formatExtraData: { col: 'farmbuilder', users },
      text: 'Farm Builder',
      align: 'center',
      headerAlign: 'center',
      dataField: 'farmbuilder',
    },
  ];

  const { SearchBar } = Search;

  return (
    <Stack align="start" style={{ paddingBottom: 24 }}>
      <ToolkitProvider
        keyField="id"
        data={users}
        columns={getColumns(users)}
        search
      >
        {/* @ts-expect-error any type */}
        {props => (
          <>
            <SearchBar
              {...props.searchProps}
              placeholder="Filter emails"
              style={{ width: 600 }}
            />

            <BootstrapTable
              headerClasses="roles-table-header"
              wrapperClasses="roles-table"
              className="test"
              style={{ overflowY: 'auto', height: '100%' }}
              striped
              {...props.baseProps}
            />
          </>
        )}
      </ToolkitProvider>
      <Button
        onClick={saveRoles}
        disabled={buttonDisabled}
        style={{ width: 300 }}
      >
        {buttonDisabled ? 'Saved' : 'Save Roles'}
      </Button>
    </Stack>
  );
};
